import { useEffect, useState } from 'react'
import axios from 'axios'

export default function useNewsSearch(query, pageNumber, language, blockedLangs) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [songs, setSongs] = useState([])
  const [hasMore, setHasMore] = useState(false)

  useEffect(() => {
    setSongs([])
  }, [query, language, blockedLangs])

  useEffect(() => {
    setLoading(true)
    setError(false)
    
    let cancel
    axios({
      method: 'GET',
      url: `https://starboxkod.com/api/news//${pageNumber}/${language}/${JSON.stringify(blockedLangs)}/`,
/*       params: { q: query, page: pageNumber }, */
      cancelToken: new axios.CancelToken(c => cancel = c)
    }).then(res => {
      setSongs(prevSongs => {
        return [...new Set([...prevSongs, ...res.data])]
      })
      setHasMore(res.data.length > 0 )
      setLoading(false)
    }).catch(e => {
      if (axios.isCancel(e)) return
      setError(true)
    })
    return () => cancel()
  }, [query, pageNumber, language, blockedLangs])
  return { loading, error, songs, hasMore}
}
